var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tabs',{staticStyle:{"height":"200px"}},[_c('el-tab-pane',{attrs:{"label":"消息发布"}},[_c('message-release')],1),_c('el-tab-pane',{attrs:{"label":"消息列表"}},[_c('message-list')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }